import { ReportNames } from 'constants/exportTypes';

import { useMutation } from '@tanstack/react-query';
import { getReportExport } from 'config/requests';
import { useStore } from 'react-admin';
import { ConfigurableExportField } from 'shared/react-admin/Export/ExportEditButton/ExportEditButton';

type UseReportExportProps = {
  filters: Record<string, any>;
  preferenceKey: ReportNames;
  onError: (error: any) => void;
  onSuccess: () => void;
};

type UseReportExportReturnValue = {
  isLoading: boolean;
  mutate: () => void;
};

export function useReportExport({
  filters,
  preferenceKey,
  onSuccess,
  onError,
}: UseReportExportProps): UseReportExportReturnValue {
  const [availableFields] = useStore<ConfigurableExportField[]>(
    `preferences.${preferenceKey}.export.availableFields`,
    [],
  );
  const [exportFields] = useStore(`preferences.${preferenceKey}.export.exportFields`, []);
  const selectedFields = exportFields.map(
    (fieldIndex) => availableFields.find((field) => field.index === fieldIndex)?.source || '',
  );

  const { mutate, isPending } = useMutation({
    mutationKey: ['export', filters, selectedFields],
    mutationFn: () => getReportExport(filters, selectedFields),
    retry: false,
    onError,
    onSuccess,
  });

  return { isLoading: isPending, mutate };
}
